var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customFormStyle"},[_c('div',{staticClass:"resetFormIcon hoverActiveStyle",on:{"click":function($event){return _vm.resetForm()}}},[_c('span',{staticClass:"iconfont icon-a-Group38206"})]),_vm._t("customForm")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }